import * as Yup from "yup";

// ----------------------------------------------------------------------

export const StoryReportSchema = Yup.object().shape({});
